import { useProgress } from '@react-three/drei'

export default function Loader() {
    const { active, progress } = useProgress()

    return active ? ( 
        <div className="loader" >
            Loading... {Math.round(progress)}%
        </div>
    ) : null
}